/* eslint-disable */
function parseLoop (base64Str, base64StrLength, reverseMap) {
  var words = []
  var nBytes = 0
  for (var i = 0; i < base64StrLength; i++) {
    if (i % 4) {
      var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2)
      var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2)
      var bitsCombined = bits1 | bits2
      words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8)
      nBytes++
    }
  }
  return WordArray.create(words, nBytes)
}

var create = Object.create || (function () {
  function F () { }
  return function (obj) {
    var subtype
    F.prototype = obj
    subtype = new F()
    F.prototype = null
    return subtype
  }
}())

var Hex = {
  stringify: function (wordArray) {
    var words = wordArray.words
    var sigBytes = wordArray.sigBytes
    var hexChars = []
    for (var i = 0; i < sigBytes; i++) {
      var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff
      hexChars.push((bite >>> 4).toString(16))
      hexChars.push((bite & 0x0f).toString(16))
    }
    return hexChars.join('')
  },
  parse: function (hexStr) {
    var hexStrLength = hexStr.length
    var words = []
    for (var i = 0; i < hexStrLength; i += 2) {
      words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4)
    }
    return new WordArray.init(words, hexStrLength / 2)
  }
}

var Base = (function () {
  return {
    extend: function (overrides) {
      var subtype = create(this)
      if (overrides) {
        subtype.mixIn(overrides)
      }
      if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
        subtype.init = function () {
          subtype.$super.init.apply(this, arguments)
        }
      }
      subtype.init.prototype = subtype
      subtype.$super = this
      return subtype
    },
    create: function () {
      var instance = this.extend()
      instance.init.apply(instance, arguments)
      return instance
    },
    init: function () {
    },
    mixIn: function (properties) {
      for (var propertyName in properties) {
        if (properties.hasOwnProperty(propertyName)) {
          this[propertyName] = properties[propertyName]
        }
      }
      if (properties.hasOwnProperty('toString')) {
        this.toString = properties.toString
      }
    },
    clone: function () {
      return this.init.prototype.extend(this)
    }
  }
}())

var WordArray = Base.extend({
  init: function (words, sigBytes) {
    words = this.words = words || []

    if (sigBytes != undefined) {
      this.sigBytes = sigBytes
    } else {
      this.sigBytes = words.length * 4
    }
  },
  toString: function (encoder) {
    return (encoder || Hex).stringify(this)
  },
  concat: function (wordArray) {
    var thisWords = this.words
    var thatWords = wordArray.words
    var thisSigBytes = this.sigBytes
    var thatSigBytes = wordArray.sigBytes
    this.clamp()
    if (thisSigBytes % 4) {
      for (var i = 0; i < thatSigBytes; i++) {
        var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff
        thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8)
      }
    } else {
      for (var i = 0; i < thatSigBytes; i += 4) {
        thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2]
      }
    }
    this.sigBytes += thatSigBytes
    return this
  },
  clamp: function () {
    var words = this.words
    var sigBytes = this.sigBytes
    words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8)
    words.length = Math.ceil(sigBytes / 4)
  },
  clone: function () {
    var clone = Base.clone.call(this)
    clone.words = this.words.slice(0)
    return clone
  },
})

var Base64 = {
  stringify: function (wordArray) {
    var words = wordArray.words
    var sigBytes = wordArray.sigBytes
    var map = this._map
    wordArray.clamp()
    var base64Chars = []
    for (var i = 0; i < sigBytes; i += 3) {
      var byte1 = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff
      var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff
      var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff
      var triplet = (byte1 << 16) | (byte2 << 8) | byte3
      for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
        base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f))
      }
    }
    var paddingChar = map.charAt(64)
    if (paddingChar) {
      while (base64Chars.length % 4) {
        base64Chars.push(paddingChar)
      }
    }
    return base64Chars.join('')
  },
  parse: function (base64Str) {
    var base64StrLength = base64Str.length
    var map = this._map
    var reverseMap = this._reverseMap
    if (!reverseMap) {
      reverseMap = this._reverseMap = []
      for (var j = 0; j < map.length; j++) {
        reverseMap[map.charCodeAt(j)] = j
      }
    }
    var paddingChar = map.charAt(64)
    if (paddingChar) {
      var paddingIndex = base64Str.indexOf(paddingChar)
      if (paddingIndex !== -1) {
        base64StrLength = paddingIndex
      }
    }
    return parseLoop(base64Str, base64StrLength, reverseMap)
  },
  _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
}

var Latin1 = {
  stringify: function (wordArray) {
    var words = wordArray.words
    var sigBytes = wordArray.sigBytes
    var latin1Chars = []
    for (var i = 0; i < sigBytes; i++) {
      var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff
      latin1Chars.push(String.fromCharCode(bite))
    }
    return latin1Chars.join('')
  },
  parse: function (latin1Str) {
    var latin1StrLength = latin1Str.length
    var words = []
    for (var i = 0; i < latin1StrLength; i++) {
      words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8)
    }
    return new WordArray.init(words, latin1StrLength)
  }
}

var Utf8 = {
  stringify: function (wordArray) {
    try {
      return decodeURIComponent(escape(Latin1.stringify(wordArray)))
    } catch (e) {
      throw new Error('Malformed UTF-8 data')
    }
  },
  parse: function (utf8Str) {
    return Latin1.parse(unescape(encodeURIComponent(utf8Str)))
  }
}

export {
  Utf8,
  Base64
}
/* eslint-enable */
